/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RegistrationRequestSource {
    PERSIANSAZE = 'Persiansaze',
    SAZEYAB = 'Sazeyab',
    DARSAKHT = 'Darsakht',
    CONSTRUCTOR_NUMBER = 'ConstructorNumber',
}
